"use strict";
const $a5fd07fa01589658$var$GRID_SIZE = 4;
class $a5fd07fa01589658$export$2e2bcd8739ae039 {
    constructor(){
        this.board = this.getState();
        this.score = 0;
        this.gameActive = false;
        this.cells = document.querySelectorAll(".field-cell");
        this.messageWin = document.querySelector(".message-win");
        this.messageLose = document.querySelector(".message-lose");
        this.assignDataAttributes();
    }
    assignDataAttributes() {
        this.cells.forEach((cell, index)=>{
            const row = Math.floor(index / $a5fd07fa01589658$var$GRID_SIZE);
            const col = index % $a5fd07fa01589658$var$GRID_SIZE;
            cell.dataset.row = row;
            cell.dataset.col = col;
        });
    }
    moveUp() {
        if (!this.gameActive) return;
        let changed = false;
        for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)if (this.moveColumnUp(col)) changed = true;
        if (changed) {
            this.getRandomTile();
            this.addCell();
        }
        this.checkGameStatus();
    }
    moveDown() {
        if (!this.gameActive) return;
        let changed = false;
        for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)if (this.moveColumnDown(col)) changed = true;
        if (changed) {
            this.getRandomTile();
            this.addCell();
        }
        this.checkGameStatus();
    }
    moveLeft() {
        if (!this.gameActive) return;
        let changed = false;
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++)if (this.moveColumnLeft(row)) changed = true;
        if (changed) {
            this.getRandomTile();
            this.addCell();
        }
        this.checkGameStatus();
    }
    moveRight() {
        if (!this.gameActive) return;
        let changed = false;
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++)if (this.moveColumnRight(row)) changed = true;
        if (changed) {
            this.getRandomTile();
            this.addCell();
        }
        this.checkGameStatus();
    }
    getScore() {
        return this.board.flat().reduce((acc, value)=>acc + value, 0);
    }
    getState() {
        return [
            ...Array($a5fd07fa01589658$var$GRID_SIZE)
        ].map(()=>Array($a5fd07fa01589658$var$GRID_SIZE).fill(0));
    }
    getRandomTile() {
        const emptyTiles = [];
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++){
            for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)if (this.board[row][col] === 0) emptyTiles.push({
                row: row,
                col: col
            });
        }
        if (emptyTiles.length) {
            const { row: row, col: col } = emptyTiles[Math.floor(Math.random() * emptyTiles.length)];
            this.board[row][col] = Math.random() < 0.9 ? 2 : 4;
            this.animateNewTile(row, col);
            return {
                row: row,
                col: col,
                value: this.board[row][col]
            };
        }
        return null;
    }
    checkWin() {
        return this.board.flat().includes(2048);
    }
    checkLose() {
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++)for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++){
            if (this.board[row][col] === 0) return false;
            const checkCol = col < $a5fd07fa01589658$var$GRID_SIZE - 1 && this.board[row][col] === this.board[row][col + 1];
            const checkRow = row < $a5fd07fa01589658$var$GRID_SIZE - 1 && this.board[row][col] === this.board[row + 1][col];
            if (checkCol || checkRow) return false;
        }
        return true;
    }
    getStatus() {
        if (this.checkWin()) return "win";
        if (this.checkLose()) return "lose";
        return `playing`;
    }
    checkGameStatus() {
        const gameStatus = this.getStatus();
        if (gameStatus === "win") {
            this.messageWin.classList.remove("hidden");
            this.showWinMessage();
            this.showConfetti();
        } else if (gameStatus === "lose") {
            this.messageLose.classList.remove("hidden");
            this.showGameOverMessage();
        }
    }
    addCell() {
        this.cells.forEach((cell, index)=>{
            const row = Math.floor(index / $a5fd07fa01589658$var$GRID_SIZE);
            const col = index % $a5fd07fa01589658$var$GRID_SIZE;
            const value = this.board[row][col];
            const hasValue = value ? ` field-cell--${value}` : "";
            cell.className = "field-cell" + hasValue;
            cell.textContent = value || "";
            this.animateAppear(row, col);
        });
    }
    deleteCell() {
        this.cells.forEach((cell)=>{
            cell.className = "field-cell";
            cell.textContent = "";
        });
    }
    start(element) {
        this.gameActive = true;
        this.score = 0;
        element.classList.replace("start", "restart");
        element.textContent = "Restart";
        this.getRandomTile();
        this.getRandomTile();
        this.addCell();
        this.assignDataAttributes();
    }
    restart(element) {
        this.gameActive = false;
        this.score = 0;
        const hasHiddenLose = this.messageLose.classList.contains("hidden");
        const hasHiddenWin = this.messageWin.classList.contains("hidden");
        if (!hasHiddenLose) this.messageLose.classList.add("hidden");
        if (!hasHiddenWin) this.messageWin.classList.add("hidden");
        element.classList.replace("restart", "start");
        element.textContent = "Start";
        this.board = this.getState();
        this.deleteCell();
        this.assignDataAttributes();
    }
    moveColumnUp(col) {
        let changed = false;
        const compressedColumn = this.board.map((row)=>row[col]).filter((value)=>value !== 0);
        for(let i = 0; i < compressedColumn.length - 1; i++)if (compressedColumn[i] === compressedColumn[i + 1]) {
            compressedColumn[i] *= 2;
            compressedColumn.splice(i + 1, 1);
            this.score += compressedColumn[i];
            this.animateMerge(i, col);
            changed = true;
        }
        while(compressedColumn.length < $a5fd07fa01589658$var$GRID_SIZE)compressedColumn.push(0);
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++){
            if (this.board[row][col] !== compressedColumn[row]) changed = true;
            this.board[row][col] = compressedColumn[row];
            this.animateMove(row, col);
        }
        return changed;
    }
    moveColumnDown(col) {
        let changed = false;
        const compressedColumn = this.board.map((row)=>row[col]).filter((value)=>value !== 0);
        for(let i = compressedColumn.length - 1; i > 0; i--)if (compressedColumn[i] === compressedColumn[i - 1]) {
            compressedColumn[i] *= 2;
            compressedColumn.splice(i - 1, 1);
            this.score += compressedColumn[i];
            this.animateMerge(i, col);
            changed = true;
        }
        while(compressedColumn.length < $a5fd07fa01589658$var$GRID_SIZE)compressedColumn.unshift(0);
        for(let row = 0; row < $a5fd07fa01589658$var$GRID_SIZE; row++){
            if (this.board[row][col] !== compressedColumn[row]) changed = true;
            this.board[row][col] = compressedColumn[row];
            this.animateMove(row, col);
        }
        return changed;
    }
    moveColumnLeft(row) {
        let changed = false;
        const compressedRow = this.board[row].filter((value)=>value !== 0);
        for(let i = 0; i < compressedRow.length - 1; i++)if (compressedRow[i] === compressedRow[i + 1]) {
            compressedRow[i] *= 2;
            compressedRow.splice(i + 1, 1);
            this.score += compressedRow[i];
            this.animateMerge(row, i);
            changed = true;
        }
        while(compressedRow.length < $a5fd07fa01589658$var$GRID_SIZE)compressedRow.push(0);
        if (this.board[row].some((value, index)=>value !== compressedRow[index])) changed = true;
        this.board[row] = compressedRow;
        for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)this.animateMove(row, col);
        return changed;
    }
    moveColumnRight(row) {
        let changed = false;
        const compressedRow = this.board[row].filter((value)=>value !== 0);
        for(let i = compressedRow.length - 1; i > 0; i--)if (compressedRow[i] === compressedRow[i - 1]) {
            compressedRow[i] *= 2;
            compressedRow.splice(i - 1, 1);
            this.score += compressedRow[i];
            this.animateMerge(row, i);
            changed = true;
        }
        while(compressedRow.length < $a5fd07fa01589658$var$GRID_SIZE)compressedRow.unshift(0);
        if (this.board[row].some((value, index)=>value !== compressedRow[index])) changed = true;
        this.board[row] = compressedRow;
        for(let col = 0; col < $a5fd07fa01589658$var$GRID_SIZE; col++)this.animateMove(row, col);
        return changed;
    }
    animateNewTile(row, col) {
        const cell = document.querySelector(`.field-cell[data-row="${row}"][data-col="${col}"]`);
        if (cell) {
            cell.classList.add("field-cell--new");
            setTimeout(()=>{
                cell.classList.remove("field-cell--new");
            }, 300);
        }
    }
    animateAppear(row, col) {
        const cell = document.querySelector(`.field-cell[data-row="${row}"][data-col="${col}"]`);
        if (cell) {
            cell.classList.add("field-cell--appear");
            setTimeout(()=>{
                cell.classList.remove("field-cell--appear");
            }, 200);
        }
    }
    animateMerge(row, col) {
        const cell = document.querySelector(`.field-cell[data-row="${row}"][data-col="${col}"]`);
        if (cell) {
            cell.classList.add("field-cell--merge");
            setTimeout(()=>{
                cell.classList.remove("field-cell--merge");
            }, 300);
        }
    }
    animateMove(row, col) {
        const cell = document.querySelector(`.field-cell[data-row="${row}"][data-col="${col}"]`);
        if (cell) {
            cell.classList.add("field-cell--move");
            setTimeout(()=>{
                cell.classList.remove("field-cell--move");
            }, 300);
        }
    }
    showGameOverMessage() {
        const gameOverOverlay = document.querySelector(".game-over-overlay");
        gameOverOverlay.classList.remove("hidden");
        setTimeout(()=>{
            gameOverOverlay.classList.add("show");
        }, 10);
        setTimeout(()=>{
            gameOverOverlay.classList.remove("show");
            setTimeout(()=>{
                gameOverOverlay.classList.add("hidden");
            }, 1000);
        }, 3000);
    }
    showWinMessage() {
        const winOverlay = document.querySelector(".win-overlay");
        winOverlay.classList.remove("hidden");
        setTimeout(()=>{
            winOverlay.classList.add("show");
        }, 10);
        setTimeout(()=>{
            winOverlay.classList.remove("show");
            setTimeout(()=>{
                winOverlay.classList.add("hidden");
            }, 1000);
        }, 3000);
    }
    createConfetti = ()=>{
        const confettiContainer = document.querySelector(".confetti-container");
        const confetti = document.createElement("div");
        confetti.classList.add("confetti");
        confetti.style.backgroundColor = `hsl(${Math.random() * 360}, 100%, 50%)`;
        confetti.style.left = `${Math.random() * 100}vw`;
        confetti.style.animationDelay = `${Math.random()}s`;
        confetti.style.animationDuration = `${Math.random() * 2 + 3}s`;
        confettiContainer.appendChild(confetti);
        setTimeout(()=>{
            confetti.remove();
        }, 5000);
    };
    showConfetti() {
        for(let i = 0; i < 100; i++)this.createConfetti();
    }
}


"use strict";
document.addEventListener("DOMContentLoaded", ()=>{
    const MESSAGE_RESTART = "Are you sure you want to start a new game? All progress will be lost.";
    const game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
    const gameStart = document.querySelector(".button");
    const score = document.querySelector(".game-score");
    const messageStart = document.querySelector(".message-start");
    const checkStatus = ()=>{
        const hasStart = gameStart.classList.contains("start");
        if (hasStart) {
            game.start(gameStart);
            messageStart.classList.add("hidden");
        } else {
            if (confirm(MESSAGE_RESTART)) {
                game.restart(gameStart);
                game.start(gameStart);
            } else return;
        }
        setUpScore();
        setUpInputOnce();
    };
    const setUpInputOnce = ()=>window.addEventListener("keydown", handleInput, {
            once: true
        });
    const setUpScore = ()=>{
        score.textContent = game.getScore();
    };
    const handleInput = (event)=>{
        switch(event.key){
            case "ArrowUp":
                game.moveUp();
                break;
            case "ArrowDown":
                game.moveDown();
                break;
            case "ArrowLeft":
                game.moveLeft();
                break;
            case "ArrowRight":
                game.moveRight();
                break;
            default:
                setUpInputOnce();
                return;
        }
        setUpScore();
        setUpInputOnce();
    };
    setUpInputOnce();
    gameStart.addEventListener("click", checkStatus);
});


//# sourceMappingURL=index.a6b2cfe8.js.map
